import { openModal } from "~/common/utils/ModalService";
import {
  AddToWishlistWizard,
  type AddToWishlistWizardProps,
} from "~/features/wishlist/components/modals/AddToWishlist/AddToWishlistWizard";

export function openAddToWishlistWizard(props: Omit<AddToWishlistWizardProps, "closePopup">) {
  return openModal("add-to-wishlist-modal", (close) => <AddToWishlistWizard closePopup={close} {...props} />);
}
